// Generated by `bazel run i18n`. Do not edit by hand.
import home_9e8793ae from "./en/src--account--home.json";
import lists_140ca752 from "./en/src--account--lists.json";
import orders_8883432d from "./en/src--account--orders.json";
import personalInfo_4bcd3f91 from "./en/src--account--personal-info.json";
import warranties_72b72e96 from "./en/src--account--warranties.json";
import account_3f53adba from "./en/src--account.json";
import login_16c6e00f from "./en/src--login.json";
import unsubscribe_c826f058 from "./en/src--marketing--unsubscribe.json";
import mobileUpload_adf7aacf from "./en/src--mobile-upload.json";
import hooks_9b9b5238 from "./en/src--order--hooks.json";
import orderEdit_d6b5145b from "./en/src--order--order-edit.json";
import fulfillment_32278f3a from "./en/src--order--order-tracking--fulfillment.json";
import recycling_ba89592b from "./en/src--order--recycling.json";
import review_c6592405 from "./en/src--order--return-flow--review.json";
import orderTrackingIframes_88cb8883 from "./en/src--order-tracking-iframes.json";
import order_9b6d226e from "./en/src--order.json";
import return_e3a35c3c from "./en/src--return.json";
import utils_bae51d68 from "./en/src--utils.json";
import policies_fda6625a from "./en/src--warranties--policies.json";
import warranties_60d45d74 from "./en/src--warranties.json";
import withdrawal_c46cd62c from "./en/src--withdrawal.json";
import src_c1a2d0b5 from "./en/src.json";

export default Object.assign(
  {},
  home_9e8793ae,
  lists_140ca752,
  orders_8883432d,
  personalInfo_4bcd3f91,
  warranties_72b72e96,
  account_3f53adba,
  login_16c6e00f,
  unsubscribe_c826f058,
  mobileUpload_adf7aacf,
  hooks_9b9b5238,
  orderEdit_d6b5145b,
  fulfillment_32278f3a,
  recycling_ba89592b,
  review_c6592405,
  orderTrackingIframes_88cb8883,
  order_9b6d226e,
  return_e3a35c3c,
  utils_bae51d68,
  policies_fda6625a,
  warranties_60d45d74,
  withdrawal_c46cd62c,
  src_c1a2d0b5,
);
